import Box from "@mui/material/Box";
import TriggerPropertiesButtons from "../TriggerPropertiesButtons";
import { styled } from "@mui/material/styles";
import { useSelector } from "react-redux";

const ScrollArea = styled(Box)(() => ({
  flex: 1,
  overflowY: "auto",
  overflowX: "hidden",
  position: "relative",
}));

const Wrapper = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
}));

const TriggerFormWrapper = ({ onSubmit, onCancel, submitting, disableSubmit, children, tabValue }) => {
  const { currentSavedFlow } = useSelector((store) => store?.designer?.flows);
  const isFlowActive = currentSavedFlow?.shared_status === "active";
  const showButtons = tabValue !== 2 && !isFlowActive;

  return (
    <Wrapper sx={tabValue === 2 ? {} : { height: "100%" }}>
      <ScrollArea>
        {children}
      </ScrollArea>

      {showButtons && (
        <Box sx={{ position: "sticky", bottom: 18, zIndex: 1300 }}>
          <TriggerPropertiesButtons
            onSubmit={onSubmit}
            onCancel={onCancel}
            submitting={submitting}
            disableSubmit={disableSubmit}
          />
        </Box>
      )}
    </Wrapper>
  );
};

export default TriggerFormWrapper;
